import { NavLink, Outlet } from 'react-router-dom';
import styles from './SettingsLayout.module.css';

interface SettingsNavItem {
  label: string;
  to: string;
}

// Sidebar label renamed from "Team" → "Employees" for 104c. The page
// used to show Memberships (Kanjoy-User rows) and is being repurposed to
// show Employees (the billable roster). "Team" was a misnomer for the
// old content; "Employees" accurately describes what the page is now.
// The Memberships surface lives under a separate "Access" entry (104d).
const SETTINGS_NAV: SettingsNavItem[] = [
  { label: 'Organization', to: '/settings/organization' },
  { label: 'Employees', to: '/settings/team' },
  { label: 'Access', to: '/settings/access' },
  { label: 'Collectors', to: '/settings/collectors' },
  { label: 'Jira integration', to: '/settings/integrations/jira' },
  { label: 'Account', to: '/settings/account' },
];

export function SettingsLayout() {
  return (
    <div className={styles.wrapper}>
      <nav className={styles.settingsNav} aria-label="Settings navigation">
        <ul className={styles.navList}>
          {SETTINGS_NAV.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                className={({ isActive }) => `${styles.navLink} ${isActive ? styles.active : ''}`}
                end
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  );
}
